/**
 * 可以上移
 */
export const canMoveUp = (page, index) => {
  return !(page == 1 && index == 0)
}

/**
 * 可以下移
 * 只有最后一页最后一条不能下移
 */
export const canMoveDown = (totalCount, page, pageSize, index) => {
  return (page - 1) * pageSize + (index + 1) < totalCount
}

/**
 *  可以置顶
 */
export const canMoveTop = (page, index) => {
  return canMoveUp(page, index)
}
